@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/colours.variables' as colours;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/spacing.variables' as spacing;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/font-weights.variables' as fontWeights;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/1-variables/global.variables' as globalVariables;
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/4-elements/_global.elements.scss';
@use 'pkg:@ongov/ontario-design-system-global-styles/styles/scss/7-overrides/_visibility.overrides.scss';

@use '../../styles/fieldsets.scss';
@use '../../styles/labels.scss';
@use '../../styles/text-inputs.scss';
@forward '../../utils/components/error-message/error-message';

.ontario-date__group {
	display: flex;

	label {
		font-weight: fontWeights.$ontario-font-weights-semi-bold;
	}

	input {
		margin-top: spacing.$spacing-4;
	}
}

.ontario-date__group-input {
	display: flex;
	flex-direction: column;
	margin-right: spacing.$spacing-5;
}

.ontario-date--error {
	input {
		border: 0.125rem solid colours.$ontario-colour-alert;
	}
}
